import {Injectable, Type} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {MvsCrudService} from "../../../../core/shared/service/crud/mvs-crud.service";
import {MvsCrudModeEnum} from "../../../../core/shared/service/crud/mvs-crud-mode.enum";
import {
    IntegrationTypeStepObjectBaseComponent
} from "../../component/object-components/integration-type-step-object-base-component/integration-type-step-object-base.component";

@Injectable({
    providedIn: 'root'
})
export class IntegrationTypeStepService extends MvsCrudService {

    constructor(protected http: HttpClient) {
        super(http, MvsCrudService.baseUrl + '/hc/integrationTypeSteps')
    }

    getObjectComponent(mode?: MvsCrudModeEnum): Type<any> {
        if (mode != MvsCrudModeEnum.create) {
            return IntegrationTypeStepObjectBaseComponent;
        }
        return null;
    }
}
